package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val core_dateformat_di_DateFormatUseCaseModule : Module get() = module {
	single() { _ -> core.dateformat.domain.DateFormatUseCase(datastoreManager=get()) } 
}
public val core.dateformat.di.DateFormatUseCaseModule.module : org.koin.core.module.Module get() = core_dateformat_di_DateFormatUseCaseModule
